import React, { useState, useEffect } from "react";
import { makeRequest } from "../../axios";

import "./admin.scss";

const ContactMessage = () => {


const [reqa, setReqa] = useState([]);


useEffect(() => {
    makeRequest.get("admin/contact").then((res) => {
      setReqa(res.data)
    } 
    )

  }, []);

  return (
    <div className="chat-container">
      {reqa.map((msg, index) => (
        <div
          key={index}
          className={`chat-message ${
            msg.name ? "other-message" : "user-message" 
          }`}
        >
          <div className="message-info">
            <span className="sender-name">
              {msg.name ? msg.name : msg.name}
            </span>
            <span className="message-time">{msg.subject}</span>
          </div>
          <div className="message-text">{msg.message}</div>
        </div>
      ))}
    </div>
  );
};

export default ContactMessage;
